/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import {
  logEvent,
  Analytics,
  setUserId,
  getAnalytics,
} from "firebase/analytics";
import { RootState } from "app/store";
import { logEventNative } from "app/api";
import { AnalyticsEventType } from "app/types";
import { isProd } from "common/utils";

export const useAnalytics = () => {
  const location = useLocation();
  const [analytics, setAnalytics] = useState<Analytics | null>(null);
  const parent = useSelector((state: RootState) => state.user.parent);

  const handleVisibilityState = useCallback(() => {
    if (parent) {
      if (window.ReactNativeWebView) {
        logEventNative({
          event:
            document.visibilityState === "visible"
              ? AnalyticsEventType.ACTIVE
              : AnalyticsEventType.BACKGROUND,
          params: {
            page_path: location.pathname,
            page_title: location.pathname,
          },
        });
      } else if (analytics) {
        logEvent(
          analytics,
          document.visibilityState === "visible"
            ? AnalyticsEventType.ACTIVE
            : AnalyticsEventType.BACKGROUND,
          {
            page_path: location.pathname,
            page_title: location.pathname,
          },
        );
      }
    }
  }, [parent?.uid]);

  useEffect(() => {
    try {
      if (!window.ReactNativeWebView) {
        const analytics = getAnalytics();
        setAnalytics(analytics);
      }
    } catch (error) {
      console.warn("Google Analytics Error.");
      console.error(error);
    }
    document.addEventListener("visibilitychange", handleVisibilityState);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityState);
    };
  }, []);

  useEffect(() => {
    if (analytics && parent) {
      setUserId(analytics, parent?.uid);
    }
  }, [analytics, parent?.uid]);

  useEffect(() => {
    if (isProd) {
      if (window.ReactNativeWebView) {
        logEventNative({
          event: "page_view",
          params: {
            page_path: location.pathname,
            page_title: location.pathname,
          },
        });
      } else if (analytics) {
        logEvent(analytics, "page_view", {
          page_path: location.pathname,
          page_title: location.pathname,
        });
      }
    }
  }, [location]);
};
